<script setup>
import SalesOverview from './SalesOverview.vue';
import SalesIndexList from './SalesIndexList.vue';

defineProps({
  sales: { type: Object, required: true },
  actions: { type: Object, required: true },
  firstName: { type: String, default: '' },
  listTabs: { type: Array, required: true },
  showManager: { type: Boolean, default: false },
  sortVisible: { type: Boolean, default: false },
  filtersVisible: { type: Boolean, default: false },
});

const emit = defineEmits([
  'openPendingCharge',
  'applyAddress',
  'toggleFilters',
  'applySort',
  'removeFilter',
]);
</script>

<template>
  <main
    data-testid="sales-index-content"
    class="flex min-w-0 flex-col gap-[21px] px-[22px] pb-8"
  >
    <SalesOverview
      v-if="sales.activeSection.value === 'painel'"
      :dashboard="sales.dashboard.value"
      :first-name="firstName"
      :loading="sales.loadingDashboard.value"
      :recent-loading="sales.loadingRecent.value"
      :updated-at="sales.listUpdatedAt.value"
      @open="sales.openDetail"
      @open-recent="sales.openRecent"
      @open-pending-charge="emit('openPendingCharge', $event)"
      @select-list="sales.selectList"
      @recent-list-change="sales.selectRecentList"
      @refresh="sales.refresh"
    />
    <SalesIndexList
      v-else
      :active-list="sales.activeList.value"
      :list-tabs="listTabs"
      :show-tabs="false"
      :show-manager="showManager"
      :filters="sales.filters.value"
      :loading-addresses="sales.loadingAddresses.value"
      :addresses="sales.addresses.value"
      :sort-visible="sortVisible"
      :filters-visible="filtersVisible"
      :agents="sales.agents.value"
      :post-sale-statuses="sales.postSaleStatuses.value"
      :busy-actions="actions.busyActions.value"
      :error="sales.error.value"
      :loading="sales.loading.value"
      :page="sales.page.value"
      :rows="sales.rows.value"
      :total-pages="sales.totalPages.value"
      :total-rows="sales.totalRows.value"
      @select-list="sales.selectList"
      @apply-address="emit('applyAddress', $event)"
      @toggle-filters="emit('toggleFilters')"
      @apply-sort="emit('applySort', $event)"
      @apply-filters="sales.applyFilters"
      @clear-filters="sales.clearFilters"
      @remove-filter="emit('removeFilter', $event)"
      @archive="actions.openArchive"
      @change-page="sales.changePage"
      @details="sales.openDetail"
      @deliver="sales.openDelivery"
      @finalize="actions.openFinalize"
      @register="sales.openRegistration"
      @restore="actions.restore"
      @review="sales.openReview"
      @signatures="sales.openSignatures"
    />
  </main>
</template>
